import React, { forwardRef } from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    label: string;
    value: string;
  }[];
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  label,
  error,
  options,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full flex flex-col gap-1.5" data-id="element-479">
        {label && <label className="font-mono text-xs text-muted-foreground uppercase tracking-widest" data-id="element-480">
            {label}
          </label>}
        <select ref={ref} className={`flex h-10 w-full rounded-none border border-border bg-background px-3 py-2 font-mono text-sm text-foreground focus-visible:outline-none focus-visible:border-primary focus-visible:ring-1 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50 ${className}`} {...props} data-id="element-481">
          {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-482">
              {opt.label}
            </option>)}
        </select>
        {error && <span className="font-mono text-xs text-destructive" data-id="element-483">{error}</span>}
      </div>;
});
Select.displayName = 'Select';